<style>
	.imgs {
	  display: flex;
	  flex-wrap: wrap;
	
	  div {
	    width: 148px;
	    height: 148px;
	    border-radius: 6px;
	    margin-right: 10px;
	    background-size: cover;
	    background-repeat: no-repeat;
	    position: relative;
	    margin-bottom: 20px;
	
	    i {
	        font-size: 20px;
	        position: absolute;
	        right: -5px;
	        top: -5px;
	
	        &:hover {
	          cursor: pointer;
	          color: #409EFF;
	        }
	    }
	  }
	  }
.el-dialog{
	width: 95%;
}
.login-form {
	margin: -9px 10px 0 10px;
	height: 200px;
	background: #007AFF;
	border-radius: 10px;
	background-color: #EEEEEE;
	box-shadow: 0 2px 10px #9B9B9B;
	padding: 20px;
}

.form-input{
	background: #ffffff;
	border-radius: 5px;
	height: 40px;
	margin: 20px 0;
	padding: 0 10px;
}
.cancel{
	text-align: right;
}
.el-message{
	min-width: 85%;
}
.import-input{
	color: orangered;
}
.el-form-item__content{
	text-align: left;
}
.avatar-img {
  width: 60px;
  height: 60px;
}

.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.el-icon-delete {
    position: absolute;
	right: 10px;
    top: 5px;
    z-index: 9;
    font-size: 22px;
    cursor: pointer;
    background: #dfd9d9;
    border-radius: 43px;
    box-shadow: 0 0 3px #333;
}

.el-icon-error {
	font-size: 16px;
	}
.el-icon-success {
	font-size: 16px;
	}
.el-icon-view{
    position: absolute;
	left:  10px;
    top: 5px;
    z-index: 9;
    font-size: 22px;
    cursor: pointer;
    background: #fff;
    border-radius: 43px;
    box-shadow: 0 0 3px #333;
}
.el-message-box__wrapper {
    position: fixed;
	top: 20%;
	}
.el-message-box {
    width: unset;
	}
</style>

<template>
  <div class="app-container">
	LUXLUX 商品情報
	<hr></hr>
	<div v-if="divShow">
		<el-row>
		  <el-col :span="24">
			<el-input v-model="pd" placeholder="商品番号を入力してください" />
		  </el-col>
		</el-row>
		<el-row>
			<el-col  :span="10">
				<el-button @click="getGoodsInfo" type="primary" round>画像アップロード</el-button>
			</el-col>
			<el-col  :span="10">
				<el-button @click="getGoodsInfo" type="info" round disabled>商品詳細</el-button>
			</el-col>
		</el-row>
	</div>
	<div slot="title" style="text-align: right;position: sticky;top: 0px;background: white;z-index: 15;" v-if="!divShow">
	<el-row>
	  <el-col :span="10">
		<el-button icon="el-icon-circle-check" type="success" @click="submitForm"
		  >保存</el-button
		>
	  </el-col>
	  <el-col :span="10">
		<el-button icon="el-icon-circle-close" plain @click="cancel" 
		  >戻る</el-button
		>
	  </el-col>
	</el-row>
	</div>
	<br />
	<el-form ref="form" :model="form" label-width="120px" size="mini" v-if="!divShow">
	  <el-row>
		<el-col :span="22">
			<el-form-item label="商品番号：" class="import-input">{{ form.id }}</el-form-item>
			<el-form-item label="外部商品番号：" class="import-input">{{ form.outerId }}</el-form-item>
			<el-form-item label="SO NO：" class="import-input">{{ form.supplyOrderId }}</el-form-item>
			<el-form-item label="仕入先：">{{form.userIdLabel}}</el-form-item>
		</el-col>
		<el-col :span="22">
			<el-form-item label="商品名称：">{{form.itemName}}</el-form-item>
			<el-form-item label="ブランド：">{{ form.brandIdLabel }}</el-form-item>
			<el-form-item label="ロケーション">{{ form.locationLabel }}</el-form-item>
			<!-- <el-form-item label="カテゴリ：">{{form.categoryIdLabel}}</el-form-item>
			<el-form-item label="サブカテゴリ：">{{ form.subCategoryIdLabel }}</el-form-item>
			<el-form-item label="ランク：">{{form.itemRankLabel}}</el-form-item> -->
		</el-col>
		
		<el-dialog :visible.sync="dialogVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		</el-row>
		        <divider style="font-size: 15pt;"><b>画像アップロード</b></divider>
		        <div>
		          <el-row>
					            <el-col>
					              <el-form-item prop="region">
					                <div style="width: 100%;display: flex;">
					                  <div class="imgs">
					                    <!-- 上传后的图片显示在这里 -->
					                    <!-- : v-dragging="{ item: item, list: coverFileList, group: 'cover' }"
					                      这种形式进行指令绑定，其中 item 就是单个对象，而 list 则是数据列表，group 则是用来声明一个组，来保证可以在一个页面中进行多个数据源的操作。 -->
					                    <div :style="{ backgroundImage: 'url(' + item.url + ')' }" v-for="(item, index) in coverFileList"
					                      v-dragging="{ item: item, list: coverFileList, group: 'cover' }" :key="index">
					                      <i class="el-icon-circle-close" @click="coverDelete(index)"></i>
					                      <i class="el-icon-view" style="width: 20px;left: 0px;" @click="showBigImg(item.url)"></i>
					                    </div>
					                    <!-- 调用element ui上传组件 -->
					                    <!-- show-file-list	是否显示已上传文件列表 -->
					                    <!-- 这里不用组件的显示，用我们自己写的，便于实现拖住 -->
					                    <el-upload drag :action="uploadImg.url" multiple :name="file_name" :show-file-list="false"
					                      list-type="picture-card" :on-success="handleAvatarSuccessNew" :before-upload="beforeAvatarUploadNew"
					                      accept=".jpg,.png,.jpeg" :on-error="coverError">
					                      <span>画像アップロード</span>
					                    </el-upload>
					                  </div>
					                </div>
					              </el-form-item>
					            </el-col>
		          </el-row>
		        </div>
	</el-form>
  </div>
</template>

<script>
import { Divider } from 'element-ui';

export default {
  name: "GoodsInfo",
  data () {
    return {
		dialogImageUrl: '',
		dialogVisible: false,
      uploadImg: {
       url: "https://mms.luxlux.top/prod-api/luxlux/luxitems/uploadItemImgJp",
       //url: "http://127.0.0.1:518/luxlux_core/luxlux/luxitems/uploadItemImgJp",
      },
	  pd:null,
	  id:null,
      srcList: [],
	  divShow:true,
      coverFileList: [], //封面图图片集
      // 表单参数
      form: {},
    };
  },
  created () {
  },
  mounted() {
    window.addEventListener("keydown", this.keyupEnter);
  },
  methods: {
	  
    // 回车事件
    keyupEnter() {
      if (window.event.keyCode == 13) {
        this.getGoodsInfo();// 查询方法
      }
    },
    /** 修改按钮操作 */
    getGoodsInfo () {
		if (this.praseStrEmpty(this.pd) == "") {
				this.$message({
					duration:0,
				  showClose: true,
				  message: '商品番号を入力してください。',
				  type: 'error'
				});
			return;
		}
		var that = this;
		this.axios({
			method:'get',
			// url:'http://127.0.0.1GoodsDetailInfo?id=' + this.pd,
			url:'https://mms.luxlux.top/prod-api/luxlux/luxitems/getDetailInfo?id=' + this.pd,
		}).then(function(response){
			if (that.praseStrEmpty(response.data.data) == "" || that.praseStrEmpty(response.data.data.id) == "") {
				that.$message({
				  showClose: true,
				  message: '商品番号が存在しません。',
				  type: 'error'
				});
				 return;
			}
			that.id = response.data.data.id
			that.divShow = false;
			that.coverFileList = [];
			if(response.data.data.image1){
			  let item = Object.assign({ 'name': 'image1', 'url': response.data.data.image1 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image2){
			  let item = Object.assign({ 'name': 'image2', 'url': response.data.data.image2 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image3){
			  let item = Object.assign({ 'name': 'image3', 'url': response.data.data.image3 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image4){
			  let item = Object.assign({ 'name': 'image4', 'url': response.data.data.image4 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image5){
			  let item = Object.assign({ 'name': 'image5', 'url': response.data.data.image5 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image6){
			  let item = Object.assign({ 'name': 'image6', 'url': response.data.data.image6 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image7){
			  let item = Object.assign({ 'name': 'image7', 'url': response.data.data.image7 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image8){
			  let item = Object.assign({ 'name': 'image8', 'url': response.data.data.image8 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image9){
			  let item = Object.assign({ 'name': 'image9', 'url': response.data.data.image9 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image10){
			  let item = Object.assign({ 'name': 'image10', 'url': response.data.data.image10 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image11){
			  let item = Object.assign({ 'name': 'image11', 'url': response.data.data.image11 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image12){
			  let item = Object.assign({ 'name': 'image12', 'url': response.data.data.image12 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image13){
			  let item = Object.assign({ 'name': 'image13', 'url': response.data.data.image13 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image14){
			  let item = Object.assign({ 'name': 'image14', 'url': response.data.data.image14 })
			  that.coverFileList.push(item);
			}
			if(response.data.data.image15){
			  let item = Object.assign({ 'name': 'image15', 'url': response.data.data.image15 })
			  that.coverFileList.push(item);
			}
			that.form = response.data.data;
		});
    },
    showBigImg (image) {
        this.dialogImageUrl = image;
        this.dialogVisible = true;
    },
	// 转换字符串，undefined,null等转化为""
	praseStrEmpty (str) {
		if (!str || str == "undefined" || str == "null" || str == null) {
			return "";
		}
		return str;
	},
	cancel(){
		this.divShow = true;
		this.pd = ''
	},
	
	    submitForm() {
	          var queryParams = {};
			  queryParams ["id"]= this.id;
			  
			queryParams["image1"] = (this.coverFileList[0])?(this.coverFileList[0].url) : '';
			queryParams["image2"] = (this.coverFileList[1])?(this.coverFileList[1].url) : '';
			queryParams["image3"] = (this.coverFileList[2])?(this.coverFileList[2].url) : '';
			queryParams["image4"] = (this.coverFileList[3])?(this.coverFileList[3].url) : '';
			queryParams["image5"] = (this.coverFileList[4])?(this.coverFileList[4].url) : '';
			queryParams["image6"] = (this.coverFileList[5])?(this.coverFileList[5].url) : '';
			queryParams["image7"] = (this.coverFileList[6])?(this.coverFileList[6].url) : '';
			queryParams["image8"] = (this.coverFileList[7])?(this.coverFileList[7].url) : '';
			queryParams["image9"] = (this.coverFileList[8])?(this.coverFileList[8].url) : '';
			queryParams["image10"] = (this.coverFileList[9])?(this.coverFileList[9].url) : '';
			queryParams["image11"] = (this.coverFileList[10])?(this.coverFileList[10].url) : '';
			queryParams["image12"] = (this.coverFileList[11])?(this.coverFileList[11].url) : '';
			queryParams["image13"] = (this.coverFileList[12])?(this.coverFileList[12].url) : '';
			queryParams["image14"] = (this.coverFileList[13])?(this.coverFileList[13].url) : '';
			queryParams["image15"] = (this.coverFileList[14])?(this.coverFileList[14].url) : '';
			  
			  var that = this;
			  this.axios({
			  	method:'post',
			  	url:'https://mms.luxlux.top/prod-api/luxlux/luxitems/updateLuxitems',
				data: queryParams
			  }).then(function(response){
				that.$message({
				  showClose: true,
				  message: 'データを更新しました。',
				  type: 'error'
				});
				})
	    },
		
		//上传成功
		handleAvatarSuccessNew(res, file){
		  if (res.status == 0) {
				  this.$message.error('画像アップロード失敗しました。');
				  return
			  }
			  let item = Object.assign({ 'name': file.name, 'url': res.imgUrl });
	
			  if (this.coverFileList.length == 15) {
				this.$message.error('アップロードされた画像が上限の15枚を超えました。');
			  } else {
				this.coverFileList.push(item);
			  }
		},
		//上传文件之前 根据自己业务补充
		beforeAvatarUploadNew (file){
		  //判断上传有没有超过次数限制
		  //验证图片格式和大小等逻辑
		},
		//上传失败函数
		coverError (err, file, fileList){
		  // this.$message.error('上传失败');
		},
		//删除上传的图片
		coverDelete (index) {
		  this.coverFileList.splice(index, 1);
		},
	
  }
};
</script>